import { getRootEnv } from '@bringg-frontend/bringg-web-infra';
import { Task } from '@bringg/types';
import moment from 'moment';
import { FilterBar2Value } from '@bringg/react-components';
import { LookupConsts } from '@bringg/dashboard-sdk';

import { mapListValues } from 'bringg-web/features/runs/runs-filter/runs-filter-utils';
import { FilterBarListItemKeys, FilterQueryObject } from './types';

const initQueryIds = (filterObject: FilterQueryObject, run_ids: number[]) => {
	const query = {
		...filterObject
	};
	if (query.task_ids) {
		query.ids = run_ids;
		delete query.task_ids;
	}

	return query;
};

const cleanEmptyEntries = (query: FilterQueryObject): FilterQueryObject =>
	Object.fromEntries(Object.entries(query).filter(([key]) => query[key]?.length));

const getRunsFromTask = (tasks: Task[], runIds: number[]): number[] => {
	const tasksRunIds = new Set(tasks.map(task => task?.run_id));
	tasksRunIds.delete(undefined);

	if (!tasksRunIds.size || !runIds?.length) return Array.from(tasksRunIds);

	const ids = runIds.reduce((prev, currentId) => {
		if (tasksRunIds.has(currentId)) prev.push(currentId);
		return prev;
	}, []);

	return ids;
};

export const handleSearch = async (value: string, key): Promise<FilterBar2Value[]> => {
	const lookUp = getRootEnv().dashboardSdk.sdk.v2.lookup;

	let listValues;

	const params: LookupConsts.BaseSearchQuery = {
		query: value
	};

	switch (key) {
		case FilterBarListItemKeys.TASKS:
			listValues = await lookUp.getTasks(params);
			break;

		case FilterBarListItemKeys.IDS:
			listValues = await lookUp.getRuns(params);
			break;

		case FilterBarListItemKeys.TITLE:
			listValues = await lookUp.getPlannedRoutes(params);
			break;

		case FilterBarListItemKeys.TEAMS:
			listValues = await lookUp.getTeams(params);
			break;

		case FilterBarListItemKeys.DRIVERS:
			listValues = await lookUp.getUsers({ ...params, roles: ['driver'] });
			break;

		default:
			return [];
	}

	return listValues?.items?.length ? mapListValues(listValues) : [];
};

export const mapQueryToFetch = async (filterObject: FilterQueryObject): Promise<FilterQueryObject> => {
	let query = filterObject;
	if (filterObject.task_ids?.length) {
		const tasks = await getRootEnv().dashboardSdk.sdk.v2.tasks.loadMany(filterObject.task_ids);
		query = initQueryIds(filterObject, getRunsFromTask(tasks, filterObject.ids));
	}
	return cleanEmptyEntries(query);
};

export const mapValuesToFilterBar = (values: FilterQueryObject) => {
	return { ...values, date: values.date ? moment(values.date) : undefined };
};

export const mapValuesFromFilterBar = (values: { [key: string]: any }) => {
	if (values[FilterBarListItemKeys.DATE]) {
		return {
			...values,
			date: values.date.format('YYYY-MM-DD')
		};
	}

	return values;
};
